import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { getDirectionClass } from '../utils/classname';
import Jumper from './Jumper';
import Prev from './Prev';
import Next from './Next';
import { paginationClass } from './styles';

var Simple =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Simple, _PureComponent);

  var _super = _createSuper2(Simple);

  function Simple() {
    _classCallCheck(this, Simple);

    return _super.apply(this, arguments);
  }

  _createClass(Simple, [{
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: paginationClass('links', getDirectionClass('section'))
        },
        /*#__PURE__*/
        React.createElement(Prev, Object.assign({}, this.props, {
          isSimple: true
        })),
        /*#__PURE__*/
        React.createElement(Jumper, Object.assign({}, this.props, {
          isSimple: true,
          size: "small"
        })),
        /*#__PURE__*/
        React.createElement(Next, Object.assign({}, this.props, {
          isSimple: true
        })))
      );
    }
  }]);

  return Simple;
}(PureComponent);

export default Simple;